import { SLIM_SCROLLBAR_CLASS } from './scrollbar';

export const FLOATING_PANEL_CLASS =
  'rounded-2xl bg-popover/90 ring-1 ring-primary/12 backdrop-blur-xl shadow-[0_18px_40px_-20px_color-mix(in_oklab,var(--color-primary)_55%,transparent)]';

export const CALENDAR_POPOVER_CLASS = `w-auto p-0 ${FLOATING_PANEL_CLASS}`;

export const FLOATING_MENU_ITEM_CLASS = 'gap-2.5 rounded-lg px-1.5 py-1.5 focus:bg-primary/6';

export const DROPDOWN_PANEL_CLASS = `p-1.5 ${FLOATING_PANEL_CLASS} ${SLIM_SCROLLBAR_CLASS}`;

export const COMBOBOX_PANEL_CLASS = `flex flex-col overflow-hidden ${DROPDOWN_PANEL_CLASS}`;

export const COMBOBOX_LIST_CLASS = `flex min-h-0 flex-1 flex-col gap-0.5 overflow-y-auto ${SLIM_SCROLLBAR_CLASS}`;

export const DROPDOWN_ITEM_CLASS = [
  'rounded-lg py-2 pl-2.5 transition-colors duration-150 motion-reduce:transition-none',
  'data-highlighted:bg-primary/8 data-highlighted:text-foreground',
  'data-selected:font-medium data-selected:text-primary',
].join(' ');
